import { h } from 'preact';
import * as BaseComp from 'components/shared/theaters/screening.js';

export default class Screening extends BaseComp.default {
	filterProvidersListPerTheater(theater, providersList) {

		const base = super.filterProvidersListPerTheater(theater, providersList);

		// Remove the direct from theater option for TCL Chinese 6 Theatres
		if (theater.masterId === 'cbc3bf88-0d87-11e7-af1b-f7b74ecbfed9') {
			return base.filter((provider) => provider !== "cinema");
		}

		return base;
	}
}
